import React from "react";

const LazyWinningTicket = React.lazy(() => import("./WinningTicket"));

const WinningTicket = (props: Record<string, any>) => (
  <React.Suspense fallback={null}>
    <LazyWinningTicket {...props} />
  </React.Suspense>
);

export default WinningTicket;
